import { createAsyncThunk } from '@reduxjs/toolkit';
import { createWhatsAppChat } from 'services/whatsAppMessaging';
import {
  ICreateWhatsAppChatPayload,
  ICreateWhatsAppChatResponse,
} from 'services/whatsAppMessaging/types';

export const ThunkCreateWhatsAppChat = createAsyncThunk<
  ICreateWhatsAppChatResponse,
  ICreateWhatsAppChatPayload
>('whatsAppMessaging/createChat', async payload => {
  const { data } = await createWhatsAppChat(payload);
  return data;
});
